// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"288":"7f0cf9e6","463":"a224aa15","988":"e58d203a"}[chunkId] + ".chunk.css";
};